/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';
    
    /**
     * Login service class
     */
    export class ComponentOperationService {
        public static $name: string = "componentOperationService";
        public static $inject: string[] = [];

        private static SEP: string = ' ';
        private static map: { [key: string]: string } = ComponentOperationService.createMap();
        private static reversedMap: { [key: string]: string } = ComponentOperationService.reverseMap();

        public static getAvailableTypes(): string[] {
            let list: string[] = [];
            for (let key in ComponentOperationService.reversedMap) {
                if (ComponentOperationService.reversedMap.hasOwnProperty(key)) {
                    list.push(key);
                }
            }
            return list;
        }

        public static getComponentOperationFromType(type: string): Models.ComponentOperation {
            let coStr: string = ComponentOperationService.reversedMap[type];
            if (type === undefined) {
                return new Models.ComponentOperation("Unknown", "Unknown");
            } else if (type === 'All') {
                return new Models.ComponentOperation(undefined, undefined);
            } else {
                let co: string[] = coStr.split(ComponentOperationService.SEP);
                return new Models.ComponentOperation(co[0], co[1]);
            } 
        }

        public static getTypeFromComponentOperation(component: string, operation: string): string {
            let type: string = ComponentOperationService.map[component + ComponentOperationService.SEP + operation];
            if (type === undefined)
                return "Unknown type";
            else
                return type;
        }

        private static createMap(): { [key: string]: string } {
            let map: { [key: string]: string } = {};
            let sep: string = ComponentOperationService.SEP;
            map[Models.FLEXO_COMPONENT + sep + Models.LOGIN_OPERATION] = "User login";
            map[Models.FLEXO_COMPONENT + sep + Models.LOGOUT_OPERATION] = "User logout";
            map[Models.FLEXO_COMPONENT + sep + Models.IMPERSONATE_OPERATION] = "Impersonation";
            map[Models.FLEXO_COMPONENT + sep + Models.EXIT_IMPERSONATE_OPERATION] = "Impersonation";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_CREATED_OPERATION] = "User created";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_SAVED_OPERATION] = "User saved";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.GROUP_CREATED_OPERATION] = "Group created";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.GROUP_SAVED_OPERATION] = "Group saved";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.GROUP_DELETED_OPERATION] = "Group deleted from organization";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_ADDED_TO_GROUP] = "User added to group";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_ADDED_TO_ROLE] = "User added to role";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_REMOVED_FROM_ORGANIZATION] = "User removed from organization";  
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_REMOVED_FROM_GROUP] = "User removed from group";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.USER_REMOVED_FROM_ROLE] = "User removed from role";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.OPERATION_CREATE_ORGANIZATION] = "Organization created";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.OPERATION_SAVE_ORGANIZATION] = "Organization updated";
            map[Models.FLEXAUTH_COMPONENT + sep + Models.OPERATION_DELETE_ORGANIZATION] = "Organization deleted";
            map[Models.FLEXO_COMPONENT + sep + Models.LOGIN_FAILED_OPERATION] = "Login failed";
            map[Models.FLEXO_COMPONENT + sep + Models.TAKE_OPERATION] = "Take";
            map[Models.FLEXO_COMPONENT + sep + Models.DROP_OPERATION] = "Drop";
            map[Models.FLEXO_COMPONENT + sep + Models.FAILED_STREAM_PIPE_OPERATION] = "Connection failed";
            map[Models.FLEXO_COMPONENT + sep + Models.LOCKED_BLOCK_OPERATION] = "Monitor locked";
            map[Models.FLEXO_COMPONENT + sep + Models.UNLOCKED_BLOCK_OPERATION] = "Monitor unlocked";
            map[Models.ALARMS_COMPONENT + sep + Models.CREATE_ALARM_OPERATION] = "Alarm";
            map[Models.FLEXO_COMPONENT + sep + Models.CONFIRM_ALARM_OPERATION] = "Alarm confirmed";
            map[Models.ALARMS_COMPONENT + sep + Models.BULK_CONFIRM_OPERATION] = "Alarm bulk confirm";
            map[Models.ALARMS_COMPONENT + sep + Models.BULK_CONFIRM_ALL_OPERATION] = "Alarm bulk confirm (admin)";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_NETWORK_NODE_OPERATION] = "Device created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.SAVE_NETWORK_NODE_OPERATION] = "Device modified";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DELETE_NETWORK_NODE_OPERATION] = "Device deleted";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_GATEWAY_OPERATION] = "Gateway created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.SAVE_GATEWAY_OPERATION] = "Gateway modified";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DELETE_GATEWAY_OPERATION] = "Gateway deleted";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_NETWORK_OPERATION] = "Network created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.SAVE_NETWORK_OPERATION] = "Network modified";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DELETE_NETWORK_OPERATION] = "Network deleted";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.START_SUPPORT_TEST_OPERATION] = "Support test started";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DEVICE_CREDENTIALS_CHANGED] = "Device credentials changed";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.END_SUPPORT_TEST_OPERATION] = "Support test ended";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_LINK_OPERATION] = "Link created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DELETE_LINK_OPERATION] = "Link deleted";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_PROBE_OPERATION] = "Probe created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.SAVE_PROBE_OPERATION] = "Probed modified";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.DELETE_PROBE_OPERATION] = "Probed deleted";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.WORKFLOW_CHANGED_OPERATION] = "Workflow changed";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.NETWORK_NODE_ORGANIZATION_CHANGED_OPERATION] = "Change to organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.NETWORK_NODE_ORGANIZATION_ADDED_OPERATION] = "Add to organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.NETWORK_NODE_ORGANIZATION_REMOVED_OPERATION] = "Remove from organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.NETWORK_ORGANIZATION_ADDED_OPERATION] = "Add to organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.NETWORK_ORGANIZATION_REMOVED_OPERATION] = "Remove from organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.GATEWAY_ORGANIZATION_ADDED_OPERATION] = "Add to organization";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.GATEWAY_ORGANIZATION_REMOVED_OPERATION] = "Remove from organization";
            // support legacy operation names
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_OPERATION] = "Device created";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.SAVE_OPERATION] = "Device modified";
            map[Models.NETWORK_NODES_COMPONENT + sep + Models.CREATE_OPERATION] = "Device deleted";
            // end legacy operations
            map[Models.CONNECTION_ROOM_COMPONENT + sep + Models.CREATE_MONITOR_OPERATION] = "Monitor created";
            map[Models.CONNECTION_ROOM_COMPONENT + sep + Models.SAVE_MONITOR_OPERATION] = "Monitor modified";
            map[Models.CONNECTION_ROOM_COMPONENT + sep + Models.DELETE_MONITOR_OPERATION] = "Monitor deleted";
            map[Models.CONNECTION_ROOM_COMPONENT + sep + Models.TRENDING_ON_OPERATION] = "Trending activated";
            map[Models.CONNECTION_ROOM_COMPONENT + sep + Models.TRENDING_OFF_OPERATION] = "Trending deactivated";
            map[Models.FLEXO_COMPONENT + sep + Models.QUICK_SETTINGS_REQUESTED_OPERATION] = "Quick setting internal requested";
            map[Models.FLEXO_COMPONENT + sep + Models.QUICK_SETTINGS_OPERATION] = "Quick setting internal set";
            map[Models.FLEXO_COMPONENT + sep + Models.QUICK_SETTINGS_EXTERNALLY_OPERATION] = "Quick setting external set";
            map[Models.FLEXO_COMPONENT + sep + Models.ADVANCED_SETTINGS_LOAD_OPERATION] = "Advanced settings load";
            map[Models.FLEXO_COMPONENT + sep + Models.ADMIN_SETTINGS_LOAD_OPERATION] = "Admin settings load";
            map[Models.FLEXO_COMPONENT + sep + Models.VIDEO_PLAY_OPERATION] = "Video play";
            map[Models.FLEXO_COMPONENT + sep + Models.VIDEO_PLAY_ATTEMPT_OPERATION] = "Video play attempt";
            map[Models.FLEXO_COMPONENT + sep + Models.VIDEO_PLAY_ERROR_OPERATION] = "Video play error";
            map[Models.WATCHDOG_COMPONENT + sep + Models.SERVICE_UP_OPERATION] = "Service up";
            map[Models.WATCHDOG_COMPONENT + sep + Models.SERVICE_DOWN_OPERATION] = "Service down";
            return map;
        }

        private static reverseMap(): { [key: string]: string } {
            let reverse: { [key: string]: string } = {};

            for (let key in ComponentOperationService.map) {
                if (ComponentOperationService.map.hasOwnProperty(key)) {
                    reverse[ComponentOperationService.map[key]] = key;
                }
            }

            return reverse;
        }

        /**
         * Constructor
         */
        constructor() {
            //
        }
    }
}
